import { useGetUrlFromPageName } from '@/hooks/useRouteConfig';
import * as strings from '@/utilities/strings';
import { PAGES } from '@/pages/PAGE_CONSTANTS';

export interface GetPageUrlProps {
  /**
   * The page name to navigate to
   */
  pageName: PAGES;
  /**
   * The params to replace in the url
   */
  params?: { [key: string]: string };
}

/**
 * Hook to get page URL with dynamic basePath from context
 * @returns Function to get page URL with optional parameters
 */
const useGetPageUrl = () => {
  const getUrlFromPageName = useGetUrlFromPageName();
  const getPageUrl = ({ pageName, params }: GetPageUrlProps) => {
    let navigatePage: string | undefined = pageName;
    navigatePage = getUrlFromPageName(pageName);
    if (!navigatePage) {
      throw new Error(`Page ${pageName} not found`);
    }
    if (params != null) {
      navigatePage = strings.urlParamsReplace(navigatePage, params);
    }
    return navigatePage;
  };

  return getPageUrl;
};

export default useGetPageUrl;
